import React from 'react';
import styled from 'styled-components';
import { Content as ContentDefault } from '~/compositions/TermsAndPolicy/commonStyles';

const Content = styled(ContentDefault)`
  background-color: ${({ theme }) => theme.colors.institucional};
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
`;

const Title = styled.h1`
  font-size: 16px;
  margin-bottom: 15px;
`;

const Description = styled.p`
  font-size: 15px;
`;

export default function ThankYou() {
  return (
    <Content>
      <Title>Obrigado</Title>
      <Description>Suas informações foram salvas com sucesso!</Description>
    </Content>
  );
}
